const NS = 'WoolLabSwatchLibrarySearchBlock';
const CLS = 'woolLabSwatchLibrarySearchBlock';
const CLS_MB_ACTIVE = 'is-active';

import Handlebars from 'handlebars';
import { param } from 'jquery';
import { WoolLabSwatchBlock } from './woolLabSwatchBlock';
import {WoolLabSwatchLibraryHelpModalBlock} from './woolLabSwatchLibraryHelpModalBlock';
import {WoolLabSaveToMoodboardModalBlock} from './woolLabSaveToMoodboardModalBlock';
import utils from '../utils';

export class WoolLabSwatchLibrarySearchBlock {

	constructor(el) {
		this.$el = $(el);

		this.$filterKeys = this.$el.find(`[data-filter-key]`);
		this.$filterDropdown = this.$el.find(`.${CLS}-filters-dropdown`);
		this.$filterDropdownBtn = this.$el.find(`.${CLS}-filters-dropdown-btn`);
		this.$fabricSwatches = this.$el.find(`.${CLS}-swatches`);
		this.$searchResultsEmpty = this.$el.find(`.${CLS}-searchResults-empty`);
		this.username = this.$el.data('username');
		this.fabricSwatches = [];
		this.$searchInp = this.$el.find(`.${CLS}-searchInput`);
		this.$refineFilterBtn = this.$el.find(`.${CLS}-filterToggle.btnRefine`);
		this.$clearFilterBtn = this.$el.find(`.${CLS}-filterToggle.btnClear`);
		this.$filterRefined = this.$el.find(`.${CLS}-searchBar-refined`);
		this.$themesCarousel = this.$el.find(`.${CLS}-themesCarousel`);
		this.$season = this.$el.find(`#season`);
		this.$theme = this.$el.find(`#theme`);
		this.$certified = this.$el.find(`#certified`);
		this.$country = this.$el.find(`#country`);
		this.$benefits = this.$el.find(`#benefits`);
		this.$archived = this.$el.find(`#archived`);

		this.getSwatchDetailApi = this.$el.data('swatchDetailApi');
		this.getSupplierDetailApi = this.$el.data('getSupplierDetailApi');
		this.isInMySwatchesApi = this.$el.data('isInMySwatchesApi');
		this.getSwatchesApi = this.$el.data('swatchesApi');
		this.getFiltersApi = this.$el.data('filtersApi');
		this.addToMySwatchesApi = this.$el.data('addToMyswatchesApi');
		this.addToMoodboardApi = this.$el.data('addToMoodboardApi');
		this.createMoodboardApi = this.$el.data('createMoodboardApi');
		this.isStudent = this.$el.data('isstudent');

		this.getMySwatchesApi = this.$el.data('myswatchesApi');
		this.getMoodboardsApi = this.$el.data('getMoodboardsApi');
		this.getAllThemes = this.$el.find(`#theme`).data('allThemes');

		// Feature flag
		this.featureMoodboardsEnabled = this.$el.data('featureMoodboardsEnabled');

		this.$loadingScreen = this.$el.find(`.${CLS}-searchResults-loadingScreen`);
		this.$loadMore = this.$el.find(`.${CLS}-searchResults-loadMore`);
		this.loadingSwatches = false;
		this.allSwatchesLoaded = false;

		this.$swatchBlock = [];

		this.myMoodboardsData = {};

		this.selectedSwatchIds = [];
		this.$saveSwatchPanel = this.$el.find(`.${CLS}-saveSwatch-panel`);
		this.$saveSwatchCount = this.$el.find(`.${CLS}-saveSwatch-text-count`);
		this.$saveSwatchHelpBtn = this.$el.find(`.${CLS}-saveSwatch-help`);
		this.$saveSwatchClearBtn = this.$el.find(`.${CLS}-saveSwatch-clear-btn`);
		this.$saveSwatchSaveBtn = this.$el.find(`.${CLS}-saveSwatch-save-btn`);
		this.$saveSwatchLocationBtn = this.$el.find(`.${CLS}-saveSwatch-toggle-btn`);

		this.pageSize = 30;
		this.pageNumber = 1;

		var url_string = window.location.href; 
		var url = new URL(url_string);
		this.$urlkeyword = url.searchParams.get("keyword");
		if(this.$urlkeyword != null && this.$urlkeyword.length > 0){
			this.$searchInp.val(this.$urlkeyword);
		}
		this.$urltheme = url.searchParams.get("theme");
		this.$urlseason = url.searchParams.get("season");
		this.$urlcertified = url.searchParams.get("certified");
		this.$urlcountry = url.searchParams.get("country");
		this.$urlbenefits = url.searchParams.get("benefits");
		this.$urlarchived = url.searchParams.get("archived");

		//this.$urlcolour = url.searchParams.get("colour");
		//this.$urlweight = url.searchParams.get("weight");
		//this.$urlcharacteristic = url.searchParams.get("characteristic");

		this.initParams();
		$('.selectpicker').selectpicker('destroy').selectpicker();
		this.handleSearchInput();
		this.handleFilterToggleBtn(this.getAllThemes);
		this.handleSavePanelBtns();
		this.handleScrollLoading();
		this.getFilters(false);
		this.getItems(false);
		this.initFilterKeys();
		this.initThemesCarousel();
		this.initFeatureFlags();
		// Global function so that it can be triggered from anyway. In particular this allows swatch modal to refresh SwatchLibrary when a swatch is added to MySwatches
		window.awiGlobalHelper = {
			...window.awiGlobalHelper,
			reloadSwatchLibraryMySwatches: () => this.getMySwatches(),
		}	
	}

	initParams(clear){
		if(clear){
			this.params = {
				count: this.pageSize,
				offset: 0,
				keyword: '',
				theme: '',
				season: '',
				certified: '',
				country: '',
				benefits: '',
				archived: 'false'
			};
		}
		else{
			this.params = {
				// siteId: this.siteId,
				count: this.pageSize,
				offset: 0,
				// pageSize: this.pageSize,
				// keyword: this.$searchInp.val() || ''
				keyword: this.$urlkeyword || '',
				theme: this.$urltheme || '',
				season: this.$urlseason || '',
				certified: this.$urlcertified || '',
				country: this.$urlcountry || '',
				benefits: this.$urlbenefits || '',
				archived: this.$urlarchived || 'false'
				//colour: this.$urlcolour || '',
				//weight: this.$urlweight || '',
				//characteristic: this.$urlcharacteristic || ''
			};
		}
	}

	initFeatureFlags() {
		if (!this.featureMoodboardsEnabled) {
			// Hide moodboard button
			this.$saveSwatchPanel.find(`[data-location='myMoodboards']`).hide();
		}
	}

	initThemesCarousel() {
		const options = {
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: false,
			dots: false,
			variableWidth: true,
			swipeToSlide: true,
		};

		this.$themesCarousel.slick(options);
	}

	getWoolLabSwatchBlockTemplate() {
		let woolLabSwatchBlock = require('../../partials/widgets/woolLabSwatchBlock.hbs');

		Handlebars.registerPartial('woolLabSwatchBlock', woolLabSwatchBlock);

		let template = `
			{{> woolLabSwatchBlock
				wg="woolLabSwatchBlock"
				ns="WoolLabSwatchBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	getFilters(archived){
		let url = this.getFiltersApi;
		if (!_.isEmpty(this.params)) {
			Object.keys(this.params).forEach((key, index) => {
				if(key === "archived"){
					url = utils.updateQueryStringParameter(url, key, this.params[key]);
				}
			});
		}
		this.updateUrl();
			$.ajax({
				type: 'GET',
				url: url,
				success: (data) => {
					if(archived != false){
						this.$season.empty();
						this.$theme.empty();
						this.$certified.empty();
						this.$country.empty();
						this.$benefits.empty();
					}
					if (data.length > 0) {
						data.forEach((item) => {
							if(item.name == "season" && item.options){
								item.seasonOptions.forEach((options) => {
									let themes = [];
									options.themes.forEach((theme) => {
										themes.push(theme);
									});
									if(this.$urlseason !== null){
										if(this.$urlseason.includes(options.name)){
											this.$season.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+options.name+`' data-themes='`+themes+`'">`+options.name+`</option>`);
										}
										else{
											this.$season.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options.name+`' data-themes='`+themes+`'">`+options.name+`</option>`);
										}
									}	
									else{
										this.$season.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options.name+`' data-themes='`+themes+`'">`+options.name+`</option>`);
									}
								});
							}
							if(item.name == "theme" && item.options){
								item.options.forEach((options) => {
									if(this.$urltheme !== null){
										if(this.$urltheme.includes(options)){
											this.$theme.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+options+`'">`+options+`</option>`);
										}
										else{
											this.$theme.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
										}
									}
									else{
										this.$theme.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
									}
								});
							}
							if(item.name == "certified" && item.options){
								item.options.forEach((options) => {
									if(this.$urlcertified !== null){
										if(this.$urlcertified.includes(options)){
											this.$certified.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+options+`'">`+options+`</option>`);
										}
										else{
											this.$certified.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
										}
									}
									else{
										this.$certified.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
									}
								});
							}
							if(item.name == "country" && item.options){
								item.options.forEach((options) => {
									if(this.$urlcountry !== null){
										if(this.$urlcountry.includes(options)){
											this.$country.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+options+`'">`+options+`</option>`);
										}
										else{
											this.$country.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
										}
									}
									else{
										this.$country.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
									}
								});
							}
							if(item.name == "benefits" && item.options){
								item.options.forEach((options) => {
									if(this.$urlbenefits !== null){
										if(this.$urlbenefits.includes(options)){
											this.$benefits.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+options+`'">`+options+`</option>`);
										}
										else{
											this.$benefits.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
										}
									}
									else{
										this.$benefits.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+options+`'">`+options+`</option>`);
									}
								});
							}
						});
					}
					if(archived != false){
						this.params.season = '';
						this.params.theme = '';
						this.params.certified = '';
						this.params.country = '';
						this.params.benefits = '';
					}
					this.selectpickerRefresh();
				},
				error: (error) => {
					console.log(error);
				},
				complete: () => {
					console.log("complete");
					this.loadingSwatches = false;
				},
			});
	}

	selectpickerRefresh(){
		this.$theme.selectpicker('refresh');
		this.$season.selectpicker('refresh');
		this.$certified.selectpicker('refresh');
		this.$country.selectpicker('refresh');
		this.$benefits.selectpicker('refresh');
	}

	// Get items (reload content)
	getItems(loadMoreSwatches) {

		if (!this.loadingSwatches && !this.allSwatchesLoaded) {
			this.loadingSwatches = true;

			let url = this.getSwatchesApi;

			if (loadMoreSwatches) {
				this.setPageNumber(this.pageNumber + 1);
				this.$loadMore.addClass('active');
			} else {
				this.$loadingScreen.addClass('active');
			}
			if (!_.isEmpty(this.params)) {
				Object.keys(this.params).forEach((key, index) => {
					url = utils.updateQueryStringParameter(url, key, encodeURIComponent(this.params[key]));
				});
			}
			this.updateUrl();
			
			$.ajax({
				type: 'GET',
				url: url,
				success: (data) => {

					this.$searchResultsEmpty.hide();

					if (!loadMoreSwatches) {
						this.$fabricSwatches.empty();
					}

					let fabricSwatchMarkup = (markup) => {
						return `
							<div class="${CLS}-swatch">
								${(markup)}
							</div>`;
					};

					if (data.length > 0) {
						data.forEach((item) => {
							item.userName = this.username;
							item.getSwatchDetailApi = this.getSwatchDetailApi;
							item.getSupplierDetailApi = this.getSupplierDetailApi;
							item.isInMySwatchesApi = this.isInMySwatchesApi;
							item.addToMySwatchesApi = this.addToMySwatchesApi;
							item.getMoodboardsApi = this.getMoodboardsApi;
							item.addToMoodboardApi = this.addToMoodboardApi;
							item.createMoodboardApi = this.createMoodboardApi;
							item.isStudent = this.isStudent;
							
							let $column = this.$fabricSwatches.append(fabricSwatchMarkup(this.getWoolLabSwatchBlockTemplate()(item)));
							new WoolLabSwatchBlock($column.find(`[data-wg="WoolLabSwatchBlock"]`).last()[0], item);
						});

						this.$swatchBlock = this.$el.find('.woolLabSwatchBlock');
						this.handleSwatchBtn();
						this.getMySwatches();

					} else {
						if (loadMoreSwatches) {
							this.allSwatchesLoaded = true;
						} else {
							this.$searchResultsEmpty.show();
						}
					}

					this.$loadingScreen.removeClass('active');
					this.$loadMore.removeClass('active');
				},
				error: (error) => {
				},
				complete: () => {
					this.loadingSwatches = false;
				},
			});
		}
	}

	getMySwatches() {
		let url = `${this.getMySwatchesApi}`;
		$.ajax({
			type: 'GET',
			url: url,
			success: (data) => {
				if(data.length > 0) {
					data.forEach((item) => {
						this.$fabricSwatches.find(`[data-id="${item.id}"]`).attr('data-saved-myswatches', 'true');
					});
				}
			},
		});
	}

	getMoodboards() {
		let url = `${this.getMoodboardsApi}`;

		$.ajax({
			type: 'GET',
			url: url,
			success: (data) => {
				this.myMoodboardsData = data;
			},
		});
	}

	// Update url after filters change
	updateUrl() {
		let uri = document.location.pathname;

		Object.keys(this.params).forEach((key, index) => {
			uri = utils.updateQueryStringParameter(uri, key, this.params[key]);
		});
		// update url without reload
		window.history.pushState('', '', uri);
	}

	handleFilterToggleBtn(getAllThemes) {
		this.$refineFilterBtn.on('click', () => {
			if(this.$refineFilterBtn.hasClass(CLS_MB_ACTIVE)) {
				this.$refineFilterBtn.removeClass(CLS_MB_ACTIVE);
				this.$filterRefined.removeClass(CLS_MB_ACTIVE);
				this.$el.removeClass('refined-open');
			}
			else {
				this.$refineFilterBtn.addClass(CLS_MB_ACTIVE);
				this.$filterRefined.addClass(CLS_MB_ACTIVE);
				this.$el.addClass('refined-open');
			}
		});
		this.$clearFilterBtn.on('click', () => {

			this.filterThemeBySeason(getAllThemes);
			this.initParams(1);
			this.setPageNumber(1);
			this.allSwatchesLoaded = false;
			window.scrollTo(0, 0);
			this.selectedSwatchIds = [];
			this.updateSelectedSwatchCount();
			this.$searchInp.val('');

			$(".selectpicker").selectpicker('deselectAll');
			$('#certified').selectpicker('val', '');
			$('#archived').selectpicker('val', 'false');
			this.$theme.selectpicker('val', '');
			this.$season.selectpicker('val', '');
			this.$certified.selectpicker('val', '');
			this.$country.selectpicker('val', '');
			this.$benefits.selectpicker('val', '');
			this.getItems(false);
			
		});
	}

	filterThemeBySeason(themes) {
		if (!themes) {
			return;
		}
		const themesArr = themes.split(",");
		$( "#theme .dropdown-item" ).remove();
		for(var i = 0; i < themesArr.length; i++){
			this.$theme.append( '<option class="woolLabSwatchLibrarySearchBlock-filters-dropdown-item dropdown-item" value="' + themesArr[i] +'">' + themesArr[i] + '</option>' );
		}
		setTimeout(() => {
			this.$theme.selectpicker('refresh');
			}, 800);
	}

	handleFilterClick($element) {
		let filterKey = $element.data('filterKey') || '';
		//let value = $element.attr('value') || '';
		let value = [];
		let selectedVal = $element.val();
		value.push(selectedVal);
		
		this.$el.find(`[data-filter-key="${filterKey}"]`).removeClass('active');
		$element.addClass('active');

		if(!(_.isNil(this.params[filterKey]) && value === '')) {
			// Ensure that the filterKey does not match the current select value
			if(this.params[filterKey] !== value) {
				if(_.isNil(value) || value === '') {
					delete this.params[filterKey];
				}
				else {
					if(filterKey === "benefits"){
						value = value[0].join(";");
					}
					this.params[filterKey] = value;
				}

				this.setPageNumber(1);
				this.allSwatchesLoaded = false;
				if(filterKey === "archived"){
					this.getFilters(true);
				}
				this.getItems(false);
			}
		}
	}

	initFilterKeys() {
		this.$filterKeys.on('change', (event) => {
			this.stringThemes = [];
			let $element = $(event.currentTarget);
			let filterKey = $element.data('filterKey') || '';

			if (filterKey === "season") {
				this.$themes = $("select :selected").map((i, $element) => $($element).attr("data-themes")).toArray();
				this.$themes.forEach((element) => this.stringThemes.push(element.split(";")));
				this.stringThemes = this.stringThemes.flat();
				this.stringThemes = this.stringThemes.filter((item,
					index) => this.stringThemes.indexOf(item) === index);
					this.stringThemes = this.stringThemes.filter(Boolean).sort().join(',');
					if(this.stringThemes.length > 0){
						this.filterThemeBySeason(this.stringThemes);
					}
					else{
						this.filterThemeBySeason(this.getAllThemes);
					}
			}
			this.handleFilterClick($element);
		});

		if(this.$urlseason && this.$urlseason.length){
			this.$urlseasonArr = this.$urlseason.split(",");
			$('#season').selectpicker('val', this.$urlseasonArr);
		}

		if(this.$urltheme && this.$urltheme.length){
			this.$urlthemeArr = this.$urltheme.split(",");
			$('#theme').selectpicker('val', this.$urlthemeArr);
		}
		if(this.$urlcountry && this.$urlcountry.length){
			this.$urlcountryArr = this.$urlcountry.split(",");
			$('#country').selectpicker('val', this.$urlcountryArr);
		}
		if(this.$urlcertified && this.$urlcertified.length){
			this.$urlcertifiedArr = this.$urlcertified.split(",");
			$('#certified').selectpicker('val', this.$urlcertifiedArr);
		}
		if(this.$urlbenefits && this.$urlbenefits.length){
			this.$urlbenefitsArr = this.$urlbenefits.split(";");
			$('#benefits').selectpicker('val', this.$urlbenefitsArr);
		}
	}


	// Search text input - on type
	handleSearchInput() {
		this.$searchInp.on('keyup', (event) => {
			if(event.keyCode === 13) {
				this.params['keyword'] = $(event.currentTarget).val().trim();
				this.setPageNumber(1);
				this.allSwatchesLoaded = false;
				this.getItems(false);
			}
		});
	}


	// Swatch button
	handleSwatchBtn() {
		this.$swatchBlock.on('click', (e) => {
			let $target = $(e.target);
			let $swatch = $(e.currentTarget);

			if ($target.hasClass('woolLabSwatchBlock-btnAddSave')) {
				// add to saved button clicked

				if ($swatch.hasClass('selected')) {
					$swatch.removeClass('selected');

					let filteredItems = this.selectedSwatchIds.filter((item) => item !== $swatch.attr('data-id'));
					this.selectedSwatchIds = filteredItems;
				} else {
					// if first swatch is already saved to my swatches
					if (this.selectedSwatchIds == 0 && $swatch.attr('data-saved-myswatches') == 'true') {
						this.$saveSwatchPanel.find('[data-location="mySwatches"]').addClass('selected');
					}

					$swatch.addClass('selected');
					this.selectedSwatchIds.push($swatch.attr('data-id'));
				}
				this.updateSelectedSwatchCount();
			}
		});
	}

	handleScrollLoading() {

		let offsetFromBottom = 200;

		const This = this;

		$(document).on('touchmove', onScroll); // for mobile
		function onScroll() {
			if ($(window).scrollTop() + offsetFromBottom > $(document).height() - $(window).height()-400) {
				This.getItems(true);
			}
		}

		$(window).scroll(function() {
			let position = $(window).scrollTop() + offsetFromBottom;
			let bottom = $(document).height() - $(window).height();

			if ( position >= bottom ) {
			   This.getItems(true);
			}
		 });
	}


	handleSavePanelBtns() {
		this.$saveSwatchClearBtn.on('click', (e) => {
            this.resetSavePanel();
        });

		this.$saveSwatchHelpBtn.on('click', (e) => {
			this.displayHelpModal();
        });

		this.$saveSwatchLocationBtn.on('click', (e) => {
			let $locationBtn = $(e.currentTarget);

			// check if save location being unselected will prompt unsaving the swatch
			if ($locationBtn.hasClass('selected') && this.selectedSwatchIds.length == 1) {
				let $selectedSwatch = this.$fabricSwatches.find(`[data-id="${this.selectedSwatchIds[0]}"]`);
				if ($locationBtn.attr('data-location') == 'mySwatches' && $selectedSwatch.attr('data-saved-myswatches') == 'true') {
					// prompt removing swatch from My Swatches
				}
			}

			$locationBtn.toggleClass('selected');

			if (this.$saveSwatchLocationBtn.hasClass('selected')) {
				this.$saveSwatchSaveBtn.removeClass('disabled');
			} else {
				this.$saveSwatchSaveBtn.addClass('disabled');
			}
        });

		this.$saveSwatchSaveBtn.on('click', () => {
			this.$saveSwatchLocationBtn.map((i, item) => {
				if ($(item).hasClass('selected')) {
					if ($(item).attr('data-location') == 'mySwatches') {
						this.addSwatchToMySwatches();
						// We dont want to reset the save panel if we're adding to moodboards too - the moodboard modal will handle that
						if (this.$saveSwatchLocationBtn.filter('.selected').length < 2){
							this.resetSavePanel();
						}
						else {
							$(item).removeClass('selected');
						}
					} else if ($(item).attr('data-location') == 'myMoodboards') {
						// this.addItemToMoodboard();
						this.displaySaveToMoodboardModal();
					}
				}
			});
        });
	}

	addSwatchToMySwatches() {
		let url = `${this.addToMySwatchesApi}`;

		$.ajax({
			data: JSON.stringify(this.selectedSwatchIds),
			dataType: 'json',
			type: 'POST',
			url: url,
			success: (data) => {
				this.getMySwatches();
			},
		});
	}

	resetSavePanel() {
		this.selectedSwatchIds = [];
		this.$swatchBlock.removeClass('selected');
		this.updateSelectedSwatchCount();
		this.$saveSwatchLocationBtn.removeClass('selected');
	}

    updateSelectedSwatchCount() {
		this.$saveSwatchCount.html(this.selectedSwatchIds.length + (this.selectedSwatchIds.length == 1 ? ' swatch' : ' swatches'));

        if (this.selectedSwatchIds.length > 0 ) {
			this.$saveSwatchPanel.addClass('active');
        } else {
			this.$saveSwatchPanel.removeClass('active');
			this.$saveSwatchLocationBtn.removeClass('selected');
        }
    }

	getHelpModalTemplate() {
        let modalWidget = require('../../partials/widgets/woolLabSwatchLibraryHelpModalBlock.hbs');

		Handlebars.registerPartial('woolLabSwatchLibraryHelpModalBlock', modalWidget);

		let template = `
			{{> woolLabSwatchLibraryHelpModalBlock
				wg="woolLabSwatchLibraryHelpModalBlock"
				ns="WoolLabSwatchLibraryHelpModalBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	displayHelpModal() {
		$(document.body).append(this.getHelpModalTemplate()(this.data));
		let $modal = $('#woolLabSwatchLibraryHelpModalBlock');
		new WoolLabSwatchLibraryHelpModalBlock($modal[0]);

		$modal.modal('show');
		$('body').css('padding-right', '0');
		$modal.css('padding', '0');

		$modal.on('shown.bs.modal', () => {
			// need to manually add "in" class so backdrop can display properly due to IDS override
			$('.modal-backdrop').addClass('in');
		});

		$modal.on('hidden.bs.modal', () => {
			$modal.remove();
			$('body').css('padding-right', '');
		});
	}

	getSaveToMoodboardModalTemplate() {
        let modalWidget = require('../../partials/widgets/woolLabSaveToMoodboardModalBlock.hbs');

		Handlebars.registerPartial('woolLabSaveToMoodboardModalBlock', modalWidget);

		let template = `
			{{> woolLabSaveToMoodboardModalBlock
				wg="woolLabSaveToMoodboardModalBlock"
				ns="WoolLabSaveToMoodboardModalBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	displaySaveToMoodboardModal() {
		$(document.body).append(this.getSaveToMoodboardModalTemplate()(this.data));
		let $modal = $('#woolLabSaveToMoodboardModalBlock');

		let modalData = {};
		modalData.getMoodboardsApi = this.getMoodboardsApi;
		modalData.addToMoodboardApi = this.addToMoodboardApi;
		modalData.createMoodboardApi = this.createMoodboardApi;
		modalData.selectedItems = this.selectedSwatchIds;
		modalData.itemType ='swatch';

		new WoolLabSaveToMoodboardModalBlock($modal[0], modalData);

		$modal.modal('show');
		$('body').css('padding-right', '0');
		$modal.css('padding', '0');

		$modal.on('shown.bs.modal', () => {
			// need to manually add "in" class so backdrop can display properly due to IDS override
			$('.modal-backdrop').addClass('in');
		});

		$modal.on('hidden.bs.modal', () => {
			$modal.remove();
			$('body').css('padding-right', '');
		});

		$modal.on('resetSavePanel', () => {
			this.resetSavePanel();
		});
	}

	setPageNumber(newPageNumber) {
		this.pageNumber = newPageNumber;
		this.params.offset = (this.pageNumber - 1) * this.pageSize;
	}
}
